(function () {
  function resetDesktopPanels(footer) {
    if (!footer) return;
    if (!window.matchMedia('(min-width: 768px)').matches) return;

    footer.querySelectorAll('.collapsible-content.collapsible-content--small').forEach(function (panel) {
      panel.style.height = 'auto';
      panel.style.maxHeight = 'none';
      panel.style.overflow = 'visible';
      panel.classList.add('is-open');
    });

    footer.querySelectorAll('.collapsible-trigger').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('is-open');
    });
  }

  function initFooterCollapsibles() {
    var footer = document.querySelector('.site-footer--mobile-premium');
    if (!footer) return;

    resetDesktopPanels(footer);

    footer.querySelectorAll('.collapsible-trigger').forEach(function (trigger) {
      if (trigger.dataset.footerCollapsibleInit) return;
      trigger.dataset.footerCollapsibleInit = 'true';

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var nextExpanded = !expanded;
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));

        trigger.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        trigger.classList.toggle('is-open', nextExpanded);

        if (!panel) return;

        panel.classList.toggle('is-open', nextExpanded);

        if (window.matchMedia('(min-width: 768px)').matches) return;

        if (nextExpanded) {
          panel.style.height = panel.scrollHeight + 'px';
        } else {
          panel.style.height = '0px';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterCollapsibles);
  } else {
    initFooterCollapsibles();
  }

  document.addEventListener('shopify:section:load', initFooterCollapsibles);

  window.addEventListener('resize', function () {
    var footer = document.querySelector('.site-footer--mobile-premium');
    if (!footer) return;
    if (window.matchMedia('(min-width: 768px)').matches) {
      resetDesktopPanels(footer);
    }
  });
})();
